import featuredImage from './images/team-marketing-services.jpg';
import gndImage from './images/works/gnd.png';
import lunozart from './images/works/lunozart.png';
import bencarthy from './images/works/bencarthy.png';
import twelve from './images/works/twelve.png';
import cyber from './images/works/cyber.png';
import blak from './images/works/blak.png';
import design from './images/works/design.jpg'



export const link_items = [
  { title: "Home", url: "/", name: "home" },
  { title: "About", url: "/about", name: 'about'},
  { title: "Services", url: "/services", name: "services"},
  { title: "Work", url: "/works", name: "work" },
  { title: "Pricing", url: "/pricing", name: "pricing"},
  // { title: "Hire", url: "/hire", name: "hire" },
  { title: "Contact", url: "/contact", name: "contact"},
  { title: "Resources", url: "/sales", name: "sales"},
]



  // Projects data array
export const projectsData = [
  {
    id: 1,
    title: 'Quality, Modern Graphic Designs',
    description: 'High Quality and converting designs made for various brands and businesses',
    image: design,
    category: 'Digital Marketing',
    link: 'https://drive.google.com/drive/folders/1ZagDNRfn9YAdtnfTgbes7ZVQAdVQUNX9'
  },
  {
    id: 2,
    title: 'Twelve Clothin',
    description: 'A full-scale e-commerce platform for a top canadian based clothing brand',
    image: twelve,
    category: 'Digital Marketing',
    link: 'https://twelveclothin.ca'
  },
  {
    id: 3,
    title: 'Lunozart Interiors',
    description: 'Visual content creation and branded page optimization.',
    image: lunozart,
    category: 'UX UI Design',
    link: 'https://www.instagram.com/lunozart_interiors?igsh=d3J0MGhxaWpsNnlu'
  },
  {
    id: 4,
    title: 'Bencarthy Travels',
    description: 'A full blown business website for a top travel agency',
    image: bencarthy,
    category: 'UX UI Design',
    link: 'https://bencarthytravels.ca'
  },
  {
    id: 5,
    title: 'GND Transportation & Logistics',
    description: 'Targeted ads, weekly page growth, and engagement strategies.',
    image: gndImage,
    category: 'Web Development',
    link: 'https://www.instagram.com/gnd_tl?igsh=ZGZtYXZncWM5NnY4'
  },
  {
    id: 6,
    title: 'CyberCohorts',
    description: 'Targeted ads, weekly page growth, and engagement strategies.',
    image: cyber,
    category: 'Web Development',
    link: 'https://instagram.com/cybercohorts?igsh=NHQ5MHVpeDdyM3d5'
  },
  {
    id: 7,
    title: 'Blak Comms',
    description: 'Business website for a canadian based internet service agency',
    image: blak,
    category: 'Web Development',
    link: 'https://blakcomms.ca'
  },
];



  // FAQ data array
export const faqData = [
  {
    id: 1,
    question: "What services does Oma Media Space Limited offer?",
    answer: "We offer full-scale digital marketing services including social media page management, sponsored ads, content creation, brand strategy, page optimization, Meta verification, Google Ads, web design & development, Google Business Profile setup, and custom email creation.",
    isOpen: true
  },
  {
    id: 2,
    question: "How much do you charge for social media management?",
    answer: "Our monthly management fee for Meta platforms (Instagram & Facebook) starts at ₦180,000, with a 3-month plan available at a discounted ₦520,000. This includes content planning, engagement, posting, analytics, and a free one-week sponsored ad.",
    isOpen: false,
  },
  {
    id: 3,
    question: "Do you offer ad services separately?",
    answer: "Yes. We run high-converting sponsored ads on Meta (Instagram/Facebook), TikTok, Snapchat, YouTube, and Google. Our ad packages start from ₦30,000 per week, depending on your budget and goals.",
    isOpen: false,
  },
  {
    id: 4,
    question: "Can you help my business get Meta verified?",
    answer: "Absolutely. We offer Meta Business Verification to increase brand credibility and ad performance. Subscription starts from ₦300,000 (6 months) or ₦450,000 annually.",
    isOpen: false,
  },
  {
    id: 5,
    question: "Do I need to provide content for page management?",
    answer: "Yes. You provide raw video and image materials. However, we handle the strategy, scripts, graphic/video editing, and scheduling. If needed, we can also shoot content at an additional cost.",
    isOpen: false,
  },
  {
    id: 6,
    question: "What type of websites do you build?",
    answer: "We build custom business websites and e-commerce platforms with full functionality, including payment gateways and mobile responsiveness. Pricing starts at ₦450,000 for business sites and $600 for e-commerce.",
    isOpen: false,
  },
  {
    id: 7,
    question: "How do I get started with your services?",
    answer: "Simply reach out via WhatsApp or Instagram or via the contact page on this website. After a brief consultation, we'll send you a rate card, collect necessary details, and begin onboarding.",
    isOpen: false,
  },
  {
    id: 8,
    question: "Do you offer one-time promotions or packages for small businesses?",
    answer: "Yes, we offer one-time content revamps, strategy sessions, and sponsored ad campaigns for both small and large businesses. For ad-related promotions, we have a detailed sponsored ads rate card available. Just let us know your business goals, and we'll recommend the best plan to meet your budget and drive results.",
    isOpen: false,
  },
  {
    id: 9,
    question: "How soon will I see results?",
    answer: "Most clients begin to see improved engagement and visibility within the first 2-4 weeks, especially when sponsored ads are included. Growth results may vary based on your niche and budget.",
    isOpen: false,
  },
  {
    id: 10,
    question: "Do you offer influencer collaborations or shoutouts?",
    answer: "Yes. Through our network of influencers and brand marketers, we can push your content to wider audiences. Prices depend on the influencer and campaign type.",
    isOpen: false,
  },
];



export const pricingData = {
  tieredMonthlyData: [
    {
      title: 'STARTER PLAN',
      details: [
        {
          tag: "Platforms",
          msg: "1 Platform (Instagram or Facebook)"
        },
        {
          tag: "Weekly Posts",
          msg: "Up to 3"
        },
        {
          tag: "Deliverables",
          msg: "Full strategy, content scheduling, professional captions, page optimization, light engagement"
        },
        {
          tag: "Monthly Price (₦)",
          msg: "₦150,000"
        },
      ]
    },
    {
      title: 'PROFESSIONAL PLAN',
      details: [
        {
          tag: "Platforms",
          msg: "2 Platforms (Instagram & Facebook)"
        },
        {
          tag: "Weekly Posts",
          msg: "Up to 6"
        },
        {
          tag: "Deliverables",
          msg: "Full Strategy + planning, graphics/video content, captions, engagement, community support reporting"
        },
        {
          tag: "Monthly Price (₦)",
          msg: "₦280,000"
        },
      ]
    },
    {
      title: 'EXECUTIVE PLAN',
      details: [
        {
          tag: "Platforms",
          msg: "3 Platforms (Instagram, Facebook + TikTok/Twitter/ LinkedIn)"
        },
        {
          tag: "Weekly Posts",
          msg: "Up to 9"
        },
        {
          tag: "Deliverables",
          msg: "Full strategy, content calendar, storytelling videos, engagement, ads setup, analytics + optimization"
        },
        {
          tag: "Monthly Price (₦)",
          msg: "₦450,000"
        },
      ]
    },
  ],
  whatYouGet: {
    title: "WHAT YOU GET IN EVERY PLAN",
    list: [
      "Structured Content Strategy",
      "Content Planning & Captioning",
      "Visual Branding (photo/video/graphic content)",
      "Page Optimization & Scheduling",
      "1 FREE OnDirectione-Week Sponsored Ad Setup Monthly (client provides budget)",
      "Monthly Growth Report",
      "Dedicated Support & Content",
    ]
  },
  recommendedAdBudget: {
    title: "RECOMMENDED AD BUDGET PER PLAN",
    subtitle: "(Client is free to adjust higher/lower, but these are proven-effective ranges.)",
    details: [
      [
        "PLAN",
        "Starter",
        "Professoinal",
        "Executive"
      ],
      [
        "RECOMMENDED BUDGET",
        "₦100,000",
        "₦170,000",
        "₦250,000"
      ], 
      [
        "AD DURATION",
          "2 Weeks",
          "2 Weeks",
          "2 Weeks"
      ],
    ]
  },
  addons: {
    title: "ADDONS & CUSTOM SERVICES",
    details: [
      [
        "SERVICE",
        'Additional Platform Management (per platform)',
        'Meta Business Suite Setup/Optimization',
        'Meta Business Verification (Business)',
        'Google Business Profile Setup',
      ],
      [
        "PRICE (₦)",
        "₦60,000/month",
        "₦25,000 (one-time)",
        "₦300,000 (6mo) / ₦450,000 (1yr)",
        "₦35,000 (one-time)"
      ]
    ]
  },
  subscriptionDiscounts: {
    title: "SUBSCRIPTION DISCOUNTS",
    details: [
      [
        "Upfront duration",
        "3 Months",
        "6 Months"
      ],
      [
        "Discount",
        "10%",
        "15%",
      ],
      [
        "Example (Professional Plan)",
        "₦52,000 x 3 = ₦756,000 (Save ₦84,000)",
        "₦238,000 x 6 = ₦1,428,000 (Save ₦252,000)",
      ]
    ]
  },
  terms: {
    title: "TERMS OF SERVICE",
    details: [
      "100% upfront payment is required before commencement.",
      "Prices are strictly non-negotiable.",
      "No refunds after payment is confirmed.",
      "Ad budgets must be provided by client and do not include Oma Media's fee.",
    ]
  },
  updatedMonthlyDeliverables: {
    title: "UPDATED MONTHLY DELIVERABLES FOR EACH PLAN",
    details: [
      {
        tag: "STARTER PLAN",
        price: "(₦150,000/month)",
        heading: "Total Content: 12 posts/month",
        list: [
          "Video Content: 3 short-form branded videos (1 talking-head, 2 text/motion graphic based)",
          "Graphic Content: 9 professionally designed graphics (ads, promos, carousels, quotes, tips)",
          "Bonus: 1 Free Sponsored Ad Setup (1 week)",
          "Page Strategy & Optimization",
          "Monthly Insight Report",
          "Caption Writing & Scheduling"
        ],
        note: "Ideal for small businesses just getting started."
      },
      {
        tag: "PROFESSIONAL PLAN",
        price: "(₦280,000/month)",
        heading: "Total Content: 18 posts/month",
        list: [
          "Video Content: 6 videos (3 influencer/talking-head + 3 text/motion graphic)",
          "Graphic Content: 12 premium visual graphics",
          "Bonus: 1 Free Sponsored Ad Setup (1 week)",
          "Targeted Content Strategy & Trend Integration",
          "Daily Page Monitoring & Engagement Support",
          "Caption Creation, Scheduling, Monthly Growth Report",
        ],
        note: "Best for established brands that want consistent momentum and growth."
      },
      {
        tag: "EXECUTIVE PLAN",
        price: "(₦450,000/month)",
        heading: "Total Content: 25 posts/month",
        list: [
          "Video Content: 8 custom videos (including influencer, storytelling, and brand showcase content)",
          "Graphic Content: 17 stunning visuals",
          "Bonus: 1 Free Sponsored Ad Setup (1 week)",
          "Community Management & Real-Time Response",
          "Advanced Strategy Execution (Campaigns, Trends, Influencer Collabs)",
          "Monthly Strategy Review + Analytics Breakdown",
          "Dedicated Account Manager",
        ],
        note: "Best for established brands that want consistent momentum and growth."
      },
    ]
  },
  paymentInfo: {
    title: "PAYMENT INFORMATION",
    msg: "All payments should be made to the official Oma Media Space Limited account:",
    acctName: "Oma Media Space Limited",
    bank: "Access Bank",
    acctNumber: "1921488171",
    note: "Once payment is made, kindly forward your payment receipt via WhatsApp to +2349168102788 for confirmation.",
    sideNote: "Note: Work will only commence after payment confirmation. All payments are final and non-refundable."
  }
}




export const adsData = {
  quickNote: {
    title: "Quick Note",
    msg: "All our ads come with expert setup, precise targeting, and clear strategy - what changes is how long your ad runs, how far it goes, and the impact it creates.",
  },
  mainData: [
    {
      title: "STARTER PLAN",
      msg: "For Small Businesses & New Brands",
      table: [
        [
          "Duration",
          "1 Week",
          "2 Weeks",
          "1 Month",
        ],
        [
          "Total Cost",
          "₦60,000",
          "₦100,000",
          "₦180,000",
        ],
        [
          "Audience Reach",
          "Low - Medium",
          "Medium",
          "High",
        ],
        [
          "Goal",
          "Lead generation & awareness",
          "More profile visits & inquiries",
          "Conversion-focused traffic",
        ]
      ],
      list: [
        "1 Post Promotion",
        "Complete Ad Setup",
        "Audience Targeting",
        "Caption Refinement",
        "Daily Monitoring",
        "End-of-campaign feedback"
      ]
    },
    {
      title: "PROFESSIONAL PLAN",
      msg: "For Growing Brands Duration",
      table: [
        [
          "Duration",
          "1 Week",
          "2 Weeks",
          "1 Month",
        ],
        [
          "Total Cost",
          "₦100,000",
          "₦170,000",
          "₦300,000",
        ],
        [
          "Audience Reach",
          "Low - Medium",
          "Medium",
          "High",
        ],
        [
          "Goal",
          "Awareness / Starter Traffic",
          "Better visibility & engagement",
          "Maximum awareness + increased conversion potential",
        ]
      ],
      list: [
        "Up to 2 Post Promotions",
        "Comprehensive Ad Setup",
        "Audience Research",
        "Optimized Captions",
        "Regular Monitoring",
        "Post-campaign Breakdown",
      ]
    },
    {
      title: "EXECUTIVE PLAN",
      msg: "For Big Companies & Premium Brands",
      table: [
        [
          "Duration",
          "1 Week",
          "2 Weeks",
          "1 Month",
        ],
        [
          "Total Cost",
          "₦150,000",
          "₦250,000",
          "₦450,000",
        ],
        [
          "Audience Reach",
          "Low - Medium",
          "Medium",
          "High",
        ],
        [
          "Goal",
          "Instant traction & credibility",
          "Sales leads + brand awareness",
          "Large-scale visibility + conversions",
        ]
      ],
      list: [
        "Up to 3 Post Promotions",
        "Top-tier Ad Setup",
        "Deep Targeting",
        "Conversion Optimization",
        "Consistent Monitoring",
        "Campaign Performance Summary",
      ]
    }

  ],
  importantToNote: {
    title: "Important to note",
    list: [
      "Ad structure and setup remains the same across all plans.",
      "What increases with higher budgets is the duration and reach, not the ad type or complexity.",
      "We offer realistic audience reach and traffic — not promises of fixed results.",
      "Conversion depends on several factors including budget, audience, and content."
    ]
  }
}


